export default __webpack_public_path__ + "static/media/config.6c54c3ce.svg";